<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="dates"
        *ngFor="let item of formData.controls; let i = index"
      >
        <table class="ir-modal-table">
          <tr>
            <td></td>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
              <i class="material-icons" (click)="openDateDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big plugin-table-cell">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdate.label' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big plugin-table-cell" [formGroupName]="i">
              <div class="ir-form-group">
                <input name="label" type="text" formControlName="label" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big plugin-table-cell">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdate.date' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big plugin-table-cell" [formGroupName]="i">
              <div class="ir-form-group">
                <input name="date" type="date" formControlName="dateValue" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big plugin-table-cell">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdate.milestone' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big plugin-table-cell" [formGroupName]="i">
              <div class="ir-form-group">
                <input name="milestone" formControlName="milestone" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big plugin-table-cell">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdate.number-of-days-after' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big plugin-table-cell" [formGroupName]="i">
              <div class="ir-form-group">
                <input name="numberOfDaysAfter" type="number" formControlName="numberOfDaysAfter" class="ir-form-set" />
              </div>
            </td>
          </tr>
        </table>
        <h2>
          <span>{{ 'plugins.installationdate.comment' | translate }}</span>
        </h2>
        <div class="ir-form-group" [formGroupName]="i">
          <textarea
            id="text"
            formControlName="comment"
            rows="3"
            placeholder="{{ 'plugins.installationdate.your-comment' | translate }}"
            class="ir-form-set"
          ></textarea>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #dateDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>record</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
